import React from 'react';
import { NavLink, useParams } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { accountsURL, accountURL, orderURL } from '@admin/config/routes';
import { Order, useTaskOrderContextQuery } from '@admin/schema';

export const Breadcrumbs: React.FC<{
  order?: Pick<Order, 'number' | 'id'>;
}> = ({ order }) => {
  const { accountID } = useParams<{ accountID: string }>();
  const { data } = useTaskOrderContextQuery({ variables: { accountID: accountID } });

  if (!data) return null;

  return (
    <Breadcrumb>
      <Breadcrumb.Item>
        <NavLink to={accountsURL()} className="text-primary">
          Accounts
        </NavLink>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <NavLink to={accountURL({ id: accountID })} className="text-primary">
          {data.account.customer.name}
        </NavLink>
      </Breadcrumb.Item>
      {order ? (
        <>
          <Breadcrumb.Item>
            <NavLink to={orderURL({ id: order.id, account: { id: accountID } })} className="text-primary">
              Task Order #{order.number}
            </NavLink>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Edit</Breadcrumb.Item>
        </>
      ) : (
        <Breadcrumb.Item active>New Task Order</Breadcrumb.Item>
      )}
    </Breadcrumb>
  );
};
